module.exports = __webpack_public_path__ + "assets/img/main-bg-2.dac6825a.png";